module.exports = __webpack_public_path__ + "static/media/icon-star-gray.6cef4ed3.svg";